import React, { useState, useRef } from "react";
import {
	Button,
	Menu,
	MenuItem,
	Box,
	List,
	ListItem,
	ListItemText,
	IconButton,
} from "@mui/material";
import { AttachmentOutlined, Delete } from "@mui/icons-material";

export default function FileUpload({ name, formik, iconOnly = false }) {
	const [anchorEl, setAnchorEl] = useState(null);
	const [cameraStream, setCameraStream] = useState(null);
	
	const fileInputRef = useRef(null);
	const videoRef = useRef(null);
	
	const uploadedFiles = formik.values[name] || [];
	
	const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
	const handleMenuClose = () => setAnchorEl(null);
	
	const handleDeviceUpload = () => {
		fileInputRef.current.click();
		handleMenuClose();
	};
	
	const handleFilesSelected = (e) => {
		const files = Array.from(e.target.files).map((file) => ({
			file,
			url: URL.createObjectURL(file),
		}));
		formik.setFieldValue(name, [...uploadedFiles, ...files]);
	};
	
	const startCamera = async () => {
		handleMenuClose();
		try {
			const stream = await navigator.mediaDevices.getUserMedia({ video: true });
			if (videoRef.current) videoRef.current.srcObject = stream;
			setCameraStream(stream);
		} catch (err) {
			console.error("Error accessing camera:", err);
			alert("Δεν μπορέσαμε να ανοίξουμε την κάμερα");
		}
	};
	
	const takePhoto = () => {
		if (!videoRef.current) return;
		
		const canvas = document.createElement("canvas");
		canvas.width = videoRef.current.videoWidth;
		canvas.height = videoRef.current.videoHeight;
		
		const ctx = canvas.getContext("2d");
		ctx.drawImage(videoRef.current, 0, 0, canvas.width, canvas.height);
		
		canvas.toBlob((blob) => {
			const file = new File([blob], `photo_${Date.now()}.png`, {
				type: "image/png",
			});
			const url = URL.createObjectURL(file);
			formik.setFieldValue(name, [...uploadedFiles, { file, url }]);
		});
		
		stopCamera();
	};
	
	const stopCamera = () => {
		if (cameraStream) {
			cameraStream.getTracks().forEach((track) => track.stop());
			setCameraStream(null);
		}
	};
	
	const handleFileDelete = (index, event) => {
		event.stopPropagation();
		const updated = [...uploadedFiles];
		updated.splice(index, 1);
		formik.setFieldValue(name, updated);
	};
	
	const handleFileClick = (fileObj) => {
		const { file, url } = fileObj;
		if (file.type.startsWith("image/")) {
			window.open(url, "_blank");
		} else {
			const a = document.createElement("a");
			a.href = url;
			a.download = file.name;
			a.click();
		}
	};
	
	return (
		<Box sx={{ width: "100%" }}>
			<IconButton size="small" onClick={handleDeviceUpload}>
			{/*<IconButton size="small" onClick={handleMenuOpen}>*/}
				<AttachmentOutlined fontSize="small" />
			</IconButton>
			
			{/*<Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>*/}
			{/*	/!*<MenuItem onClick={startCamera}>Camera</MenuItem>*!/*/}
			{/*	<MenuItem onClick={handleDeviceUpload}>Device</MenuItem>*/}
			{/*</Menu>*/}
			
			<input
				type="file"
				ref={fileInputRef}
				style={{ display: "none" }}
				onChange={handleFilesSelected}
				multiple
			/>
			
			{cameraStream && (
				<Box mt={2}>
					<video
						ref={videoRef}
						autoPlay
						playsInline
						style={{
							width: "100%",
							maxWidth: 320,
							borderRadius: 8,
							border: "1px solid #ccc",
						}}
					/>
					<Box mt={1} display="flex" gap={1}>
						<Button size="small" variant="outlined" onClick={takePhoto}>
							Take Photo
						</Button>
						<Button size="small" variant="outlined" onClick={stopCamera}>
							Stop Camera
						</Button>
					</Box>
				</Box>
			)}
			
			{!iconOnly && uploadedFiles.length > 0 && (
				<Box mt={1}>
					<List dense>
						{uploadedFiles.map((fileObj, index) => (
							<ListItem
								key={index}
								onClick={() => handleFileClick(fileObj)}
								secondaryAction={
									<IconButton
										edge="end"
										size="small"
										onClick={(e) => handleFileDelete(index, e)}
									>
										<Delete fontSize="small" />
									</IconButton>
								}
								sx={{ cursor: "pointer" }}
							>
								<ListItemText primary={fileObj.file.name} />
							</ListItem>
						))}
					</List>
				</Box>
			)}
		</Box>
	);
}
